// SCSS variables converted to JavaScript for Material-UI theme
// This replaces the problematic sass-vars-to-js-loader dependency

export const vars = {
  // Primary colors - Deep Navy theme
  primary: "#3c3c3c",
  primaryLight: "#565656", // Lighter gray for hover states
  primaryDark: "#2c2c2c", // Darker gray for active states
  
  // Secondary colors - Yellow theme
  secondary: "#FFD700", // Gold yellow
  secondaryLight: "#FFE44D", // Lighter yellow for backgrounds
  secondaryDark: "#CCB100", // Darker yellow for emphasis
  
  // Semantic colors for consistent UI feedback
  success: "#4CAF50", // Green for success states
  successLight: "#81C784",
  successDark: "#388E3C",
  
  warning: "#FF9800", // Orange for warning states
  warningLight: "#FFB74D",
  warningDark: "#F57C00",
  
  error: "#F44336", // Red for error states
  errorLight: "#EF5350",
  errorDark: "#D32F2F",
  
  info: "#2196F3", // Blue for informational states
  infoLight: "#64B5F6",
  infoDark: "#1976D2",
  
  // Neutral colors for backgrounds and text
  grey50: "#FAFAFA",
  grey100: "#F5F5F5",
  grey200: "#EEEEEE",
  grey300: "#E0E0E0",
  grey400: "#BDBDBD",
  grey500: "#9E9E9E",
  grey600: "#757575",
  grey700: "#616161",
  grey800: "#424242",
  grey900: "#212121",
  
  // Legacy colors (deprecated - use semantic colors instead)
  inheritDefault1: "#fefefe",
  inheritDefault2: "#f8f9ff",
  second: "#070919",
  indigo: "#7420ff",
  purple: "#793de6",
  pink: "#fc26a4",
  red: "#f83245",
  orange: "#f4772e",
  yellow: "#ffc926",
  green: "#1bc943",
  teal: "#18e1a5",
  cyan: "#27dcf3"
};

export default vars;
